import { fork } from 'redux-saga/effects';

import { createArtsetSaga } from './sagas/createArtset';
import { fetchArtsSaga } from './sagas/fetchArts';
import { createArtProductSaga } from './sagas/createArtProduct';
import { updateArtProductSaga } from './sagas/updateArtProduct';
import { deleteArtProductSaga } from './sagas/deleteArtProduct';

export const artsSaga = function* () {
  yield fork(createArtsetSaga);
  yield fork(fetchArtsSaga);
  yield fork(createArtProductSaga);
  yield fork(updateArtProductSaga);
  yield fork(deleteArtProductSaga);
};
